import { vdkEmHappinessPortalApi } from './vdk-em-happiness-portal-api';
const createInterest = (payload) => {
    return vdkEmHappinessPortalApi.post('/interests/create', payload);
};
const updateInterest = (payload) => {
    return vdkEmHappinessPortalApi.put('/interests/update', payload);
};
const getAllInterests = (payload) => {
    return vdkEmHappinessPortalApi.post('/interests/get-all', payload);
};
const getAllInterestsWithoutPagination = () => {
    return vdkEmHappinessPortalApi.get('/interests/get-all-without-pagination');
};
const getInterestById = (id) => {
    return vdkEmHappinessPortalApi.get(`/interests/${id}`);
};
const deleteInterest = (id) => {
    return vdkEmHappinessPortalApi.delete(`/interests/${id}`);
};
const InterestsApi = {
    createInterest,
    updateInterest,
    getAllInterests,
    getInterestById,
    deleteInterest,
    getAllInterestsWithoutPagination
};
export default InterestsApi;
